export default __webpack_public_path__ + "static/media/A&RRemovals.4d799329.jpg";